import React from 'react';

import { MomentPhoto, MomentText } from 'components';
import { stringToCSSObject, transformWithPrefix } from 'helpers/string';
import { limitTransform } from 'helpers/photo';

import cx from 'classnames';
import styles from './styles.scss';

const DEFAULT_TRANSFORM = { width: 1, x: 0, y: 0 };

export default class Moment extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      focused: false,
      zoomed: false,
    };
  }

  setFocus = (focused, zoomed = false) => {
    this.setState({
      focused,
      zoomed,
    });
  };

  render() {
    const { focused } = this.state;
    const {
      index,
      scale,
      info,
      design,
      picked,
      preview,
      pageWidth,
    } = this.props;
    const momentId = info.get('id');
    const transform = picked.get('transform', null);
    const autoSize = design.getIn(['options', 'size_to_content'], false);
    const border = design.getIn(['options', 'border'], false);

    const classes = cx(styles.moment, {
      [styles.picked]: picked.get('photo'),
      [styles.focused]: focused,
      [styles.autoSize]: autoSize,
    });

    const photo = picked.get('photo', null);
    const momentWidth = Math.round(design.get('width') * scale);
    const momentHeight = Math.round(design.get('height') * scale);
    const momentMaxWidth = design.get('max-width') ? Math.round(design.get('max-width') * scale) : 100000;
    const momentMaxHeight = design.get('max-height') ? Math.round(design.get('max-height', 0) * scale) : 100000;
    const rotate = parseInt(design.getIn(['options', 'rotate'], 0));

    const leftPage = design.get('x') < pageWidth;

    const style = {
      zIndex: (index + 1) * 1000,
      left: Math.round(design.get('x') * scale) + 'px',
      top: Math.round(design.get('y') * scale) + 'px',
      [transformWithPrefix]: rotate ? `rotate(${rotate}deg)` : null,
      ...(!autoSize ? {
        width: momentWidth + 'px',
        height: momentHeight + 'px',
      } : {
        minWidth: momentWidth + 'px',
        minHeight: momentHeight + 'px',
        left: Math.round(design.get('x') * scale * 1.5) + 'px',
        top: Math.round(design.get('y') * scale * 1.5) + 'px',
        [transformWithPrefix]: 'translate(-50%, -50%)',
      }),
      ...(momentMaxWidth ? {
        maxWidth: momentMaxWidth + 'px',
      } : {}),
      ...(momentMaxHeight ? {
        maxHeight: momentMaxHeight + 'px',
      } : {}),
    };

    let content = null;
    let customStyle = stringToCSSObject(design.getIn(['options', 'css'], ''));

    // Photo
    if (info.get('type') === 'photo') {
      const t = transform ? transform.toJS() : DEFAULT_TRANSFORM;
      const limitedTransform = photo
        ? limitTransform(
          {
            ...photo.get('exif'),
            ...preview.toJS(),
          },
          t,
          scale,
          momentWidth,
          momentHeight,
        )
        : t;

      content = (
        <MomentPhoto
          momentId={momentId}
          scale={scale}
          photo={photo}
          design={design}
          blackAndWhite={design.getIn(['options', 'black_white'], false)}
          transform={limitedTransform}
          preview={preview}
          style={customStyle}
          momentWidth={momentWidth}
          momentHeight={momentHeight}
          rotate={rotate}
        />
      );

      customStyle = null;
    }
    // Text
    else if (info.get('type') === 'text') {

      content = (
        <MomentText
          momentId={momentId}
          scale={scale}
          design={design}
          setFocus={this.setFocus}
          text={picked.get('text')}
          autoSize={autoSize}
          onLeftPage={leftPage}
          style={customStyle}
          autoSizeProps={{
            minWidth: momentWidth,
            maxWidth: momentMaxWidth,
            minHeight: momentHeight,
            maxHeight: momentMaxHeight,
          }}
        />
      );
    }

    const labelStyle = {
      fontSize: Math.round(5 * scale) + 'px',
    };

    return (
      <div className={classes} style={style}>
        {!!border && <div
          className={styles.border}
          style={{
            border: `${border.get('thickness') * scale}px solid ${border.get('color')}`,
            width: `calc(100% + ${border.get('spacing') * scale * 2}px)`,
            height: `calc(100% + ${border.get('spacing') * scale * 2}px)`,
            top: `-${border.get('spacing') * scale}px`,
            left: `-${border.get('spacing') * scale}px`,
          }}
        />}
        {content || (
          <div className={styles.label} style={labelStyle}>
            {info.get('label')}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/moment/index.js